import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';
import { navigationGroups } from '../../constants/navigation-groups';

interface BreadcrumbsProps {
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ className = '' }) => {
  const location = useLocation();
  const path = location.pathname;

  if (path === '/') return null;

  let currentGroup: (typeof navigationGroups)[0] | undefined;
  let currentItem: (typeof navigationGroups)[0]['items'][0] | undefined;

  for (const group of navigationGroups) {
    const item = group.items.find((i) => (i.path === '/' ? path === '/' : path.startsWith(i.path)));
    if (item) {
      currentGroup = group;
      currentItem = item;
      break;
    }
  }

  if (!currentItem) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn('flex items-center gap-1.5 text-sm px-4 lg:px-6 py-2.5', className)}
    >
      <ol className="flex items-center gap-1.5 list-none p-0 m-0">
        <li className="flex items-center gap-1.5">
          <Link
            to="/"
            className="flex items-center gap-1 text-gray-400 dark:text-gray-500 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          >
            <Home className="w-3.5 h-3.5" />
            <span className="sr-only sm:not-sr-only">Home</span>
          </Link>
        </li>

        {currentGroup && currentGroup.id !== 'dashboard' && (
          <li className="flex items-center gap-1.5">
            <ChevronRight className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600" aria-hidden="true" />
            <span className="text-gray-400 dark:text-gray-500">{currentGroup.label}</span>
          </li>
        )}

        <li className="flex items-center gap-1.5">
          <ChevronRight className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600" aria-hidden="true" />
          <span className="text-gray-700 dark:text-gray-200 font-medium" aria-current="page">
            {currentItem.name}
          </span>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
